import { graphql } from '@teachino/shared-infrastructure';

export const deleteFolderMutation = graphql(`
  mutation DeleteFolder($id: String!) {
    removeLibraryFolder(libraryFolderRemoveInput: { id: $id }) {
      done
      __typename
    }
  }
`);
